import { createSelector } from 'reselect'
import { get } from 'lodash'

const sections = api => api.codeLists.activitySections.list

const mapForDropdown = sections => {
  const list = sections.map(item => ({
    value:get(item, 'value'),
    label: get(item, 'label')
  }))

  return list
}

export default createSelector(sections, mapForDropdown)
